import React from "react";

// Official UAICARD Business logo (horizontal wordmark).
// Use `chip` on dark backgrounds so the original colors stay visible.
const BrandLogo = ({ className = "h-9 w-auto", chip = false }) => {
  const img = (
    <img
      src="/logo-uaicard.png"
      alt="UAICARD Business"
      className={className}
      draggable={false}
    />
  );
  if (!chip) return img;
  return (
    <span className="inline-flex items-center rounded-xl bg-white px-3 py-1.5 shadow-sm">
      {img}
    </span>
  );
};

export default BrandLogo;
